/*
 * File: ZoomInfoSelected.tsx
 * Project: a-a
 * File Created: Wednesday, 29th October 2025 10:00:16 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Wednesday, 19th November 2025 8:30:48 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */

import React, { useEffect, useState } from 'react';
import { Box, Chip, Skeleton, Typography, useTheme } from '@mui/material';
import OverviewTab from '../../../shared/CustomDashboard/Overview/OverviewTab';
import CustomHomepage from '../../../shared/CustomHomePage/CustomHomepage';
import { ZoomInfoService } from '../../../../service/zoominfo.service';
import { Link, useLocation, useParams } from 'react-router-dom';
import zeplinColor from '../../../../theme/Color';
import ZoominfoOverview from '../ZoominfoOverview/ZoominfoOverview';
import ZoominfoEmployee from '../ZoominfoEmployee/ZoominfoEmployee';
import ZoominfoNews from '../ZoominfoNews/ZoominfoNews';
import ZoominfoCompanies from '../ZoominfoCompanies/ZoominfoCompanies';
import CustomCard from '../../../shared/CustomCard/CustomCard';
import styles from './ZoomInfoSelected.module.css';
import { Utilities } from '../../../../utilities/utilities';

const ZoomInfoSelected = () => {
  const theme = useTheme();
  const location = useLocation();
  const [dataDetails, setDataDetails] = useState<any>({});
  const [exportLoading, setExportLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [value, setValue] = React.useState(0);
  const [alert, setAlert] = React.useState('');
  const [copy, setCopy] = useState('');
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    sessionStorage.setItem('currentTab', newValue.toString());
    setValue(newValue);
  };
  const handleClose = () => {
    setAlert('');
  };
  const exportData = async (id: string) => {
    try {
      setExportLoading(true);
      const res = await ZoomInfoService.exportCompanyData(id);
      console.log(res);
      Utilities.downloadCSV(res, dataDetails?.name || 'company');
    } catch (err) {
      setAlert('Something went wrong');
    } finally {
      setExportLoading(false);
    }
  };
  const getDetails = async (id: string) => {
    try {
      setLoading(true);
      const res = await ZoomInfoService.getCompanyDetails(id);
      console.log(res);
      setDataDetails(res);
      // getHierchy(res?.item?.id);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };
  const getHierchy = async (id: string) => {
    try {
      setLoading(true);
      const res = await ZoomInfoService.getHierchy(id);
      console.log(res);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };
  const handleCopyLink = () => {
    // console.log(location);
    navigator.clipboard.writeText(
      `https://app.zoominfo.com/#/apps/profile/company/${dataDetails?.item?.id}/overview`,
    );
    setAlert(`Link copied successfully`);
  };
  const DashboardTabs = [
    {
      label: 'Overview',
      id: 1,
      isHidden: value !== 0,
      Component: (
        <Box>
          <ZoominfoOverview data={dataDetails} setValue={setValue} />
        </Box>
      ),
    },
    {
      label: 'Employees',
      id: 2,
      isHidden: value !== 1,
      Component: (
        <Box>
          <ZoominfoEmployee />
        </Box>
      ),
    },
    {
      label: 'News',
      id: 3,
      isHidden: value !== 2,
      Component: (
        <Box>
          <ZoominfoNews />
        </Box>
      ),
    },
    {
      label: 'Similar Companies',
      id: 4,
      isHidden: value !== 3,
      Component: (
        <Box>
          <ZoominfoCompanies data={dataDetails?.item?.competitors} loading={loading} />
        </Box>
      ),
    },
  ];
  console.log({ location });
  useEffect(() => {
    getDetails(location?.pathname.split('/')[2] || '');
  }, [location?.pathname.split('/')[2]]);
  return (
    <>
      <CustomHomepage
        CTA={
          <Link
            to={'https://login.zoominfo.com/'}
            style={{ color: zeplinColor.BasicBlack, textDecoration: 'none' }}
            target='_blank'
            rel='noopener noreferrer'
          >
            <CustomCard
              styles={{
                borderRadius: '50px',
                padding: { xs: '8px 8px 8px 14px', xl: '10px 10px 10px 16px' },
                backgroundColor: zeplinColor.Neutral1,
                border: `1px solid ${zeplinColor.Neutral6}`,
                display: 'flex',
                gap: '8px',
                // flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'space-between',
                cursor: 'pointer',
              }}
            >
              <Typography variant='responsiveBody3'>ZoomInfo</Typography>
              <img src='/assets/link-2.svg' className={styles['zoomLink']} />
            </CustomCard>
          </Link>
        }
        sportsData={[]}
        ProfileDetails={
          <Box
            sx={{ display: 'flex', gap: '24px', padding: '10px', flexDirection: 'column', flex: 1 }}
          >
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Box sx={{ display: 'flex', gap: '16px' }}>
                {loading ? (
                  <Skeleton
                    variant='rounded'
                    width={60}
                    height={60}
                    sx={{ backgroundColor: zeplinColor.Neutral4 }}
                  />
                ) : (
                  <img
                    src={dataDetails?.item?.logo || ''}
                    alt='logo'
                    loading='lazy'
                    style={{
                      objectFit: 'contain',
                      borderRadius: '8px',
                      backgroundColor: zeplinColor.Neutral1,
                      width: '60px',
                      height: '60px',
                    }}
                    onError={(e) => {
                      e.currentTarget.onerror = null;
                      e.currentTarget.src = '/assets/zoominfo-fallback.svg';
                    }}
                  />
                )}
                <Box
                  sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
                >
                  {loading ? (
                    <Skeleton
                      variant='text'
                      sx={{
                        fontSize: theme.typography.body2,
                        width: '5rem',
                        backgroundColor: zeplinColor.Neutral4,
                        // Optionally adjust other styles here
                      }}
                    />
                  ) : (
                    <Typography variant='responsiveHeading1' color={zeplinColor.Neutral1}>
                      {dataDetails?.item?.name}
                    </Typography>
                  )}
                  <Box sx={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                    <Box sx={{ display: 'flex', gap: '4px' }}>
                      <img
                        src={'/assets/zoominfo-website.svg'}
                        alt='website'
                        loading='lazy'
                        style={{ width: '20px', height: '20px' }}
                      />
                      {loading ? (
                        <Skeleton
                          variant='text'
                          sx={{
                            fontSize: theme.typography.body2,
                            width: '5rem',
                            backgroundColor: zeplinColor.Neutral4,
                            // Optionally adjust other styles here
                          }}
                        />
                      ) : (
                        <Typography variant='responsiveBody3' color={zeplinColor.Neutral1}>
                          {dataDetails?.item?.website}
                        </Typography>
                      )}
                    </Box>
                    {/* <Chip
                      label={
                        loading ? (
                          <Skeleton
                            variant='text'
                            sx={{
                              fontSize: theme.typography.body2,
                              width: '5rem',
                              backgroundColor: zeplinColor.Neutral4,
                              // Optionally adjust other styles here
                            }}
                          />
                        ) : (
                          <Typography
                            variant='responsiveLabel1'
                            sx={{ display: 'flex', alignItems: 'center' }}
                            color={zeplinColor.Neutral1}
                          >
                            Target Account
                          </Typography>
                        )
                      }
                      sx={{
                        backgroundColor: zeplinColor.Neutral10,
                        color: zeplinColor.Neutral1,
                        '&.MuiChip-root': {
                          height: '24px',
                          padding: '5px 12px',
                          borderRadius: '50px',
                        },
                        '& .MuiChip-label': {
                          padding: 0,
                        },
                      }}
                    /> */}
                  </Box>
                </Box>
              </Box>
              <Box sx={{ display: 'flex', gap: '12px' }}>
                <Box
                  sx={{
                    padding: '6px 16px',
                    borderRadius: '8px',
                    border: `1px solid ${zeplinColor.Neutral1}`,
                    display: 'flex',
                    gap: '8px',
                    width: 'auto',

                    alignItems: 'center',
                    height: '32px',
                  }}
                  onClick={handleCopyLink}
                >
                  <img
                    src={'/assets/copy-white.svg'}
                    alt='logo'
                    loading='lazy'
                    style={{ width: '20px', height: '20px', display: 'block', margin: 'auto' }}
                  />
                  <Typography variant='responsiveButtonSmall' color={zeplinColor.Neutral1}>
                    Copy Link
                  </Typography>
                </Box>
                <Box
                  sx={{
                    padding: '6px 16px',
                    borderRadius: '8px',
                    display: 'flex',
                    gap: '8px',
                    width: 'auto',
                    backgroundColor: exportLoading ? zeplinColor.Neutral4 : zeplinColor.Brand1,
                    alignItems: 'center',
                    height: '32px',
                  }}
                  onClick={() => {
                    !exportLoading && exportData(location?.pathname.split('/')[2]);
                  }}
                >
                  <Typography
                    variant='responsiveButtonSmall'
                    color={exportLoading ? zeplinColor.BasicBlack : zeplinColor.Neutral1}
                  >
                    {exportLoading ? 'Exporting...' : 'Export'}
                  </Typography>
                  {/* <img
                    src={'/assets/down-arrow-white.svg'}
                    alt='logo'
                    loading='lazy'
                    style={{ width: '20px', height: '20px', display: 'block', margin: 'auto' }}
                  /> */}
                </Box>
              </Box>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                <img
                  src={'/assets/zoominfo-location.svg'}
                  alt='logo'
                  loading='lazy'
                  style={{
                    width: '20px',
                    height: '20px',
                  }}
                />
                {loading ? (
                  <Skeleton
                    variant='text'
                    sx={{
                      fontSize: theme.typography.body2,
                      width: '5rem',
                      backgroundColor: zeplinColor.Neutral4,
                      // Optionally adjust other styles here
                    }}
                  />
                ) : (
                  <Typography variant='responsiveBody3' color={zeplinColor.Neutral1}>
                    {dataDetails?.item?.street}
                    {`${dataDetails?.item?.street ? ', ' : ''}`}
                    {dataDetails?.item?.city}
                    {`${dataDetails?.item?.city ? ', ' : ''}`}
                    {dataDetails?.item?.zipCode}
                    {`${dataDetails?.item?.zipCode ? ', ' : ''}`}
                    {dataDetails?.item?.country}
                  </Typography>
                )}
              </Box>
              <Box
                sx={{
                  height: '16px',
                  width: '1px',
                  backgroundColor: zeplinColor.Neutral9,
                  display: 'inline-block',
                  marginX: '4px', // Add some margin on both sides
                }}
              />

              <Box sx={{ display: 'flex', gap: '8px' }}>
                <img
                  src={'/assets/zoominfo-industry.svg'}
                  alt='logo'
                  loading='lazy'
                  style={{
                    width: '20px',
                    height: '20px',
                  }}
                />
                {loading ? (
                  <Skeleton
                    variant='text'
                    sx={{
                      fontSize: theme.typography.body2,
                      width: '5rem',
                      backgroundColor: zeplinColor.Neutral4,
                      // Optionally adjust other styles here
                    }}
                  />
                ) : (
                  <Typography variant='responsiveBody3' color={zeplinColor.Neutral1}>
                    {dataDetails?.item?.industries?.join(',')}
                  </Typography>
                )}
              </Box>
              <Box
                sx={{
                  height: '16px',
                  width: '1px',
                  backgroundColor: zeplinColor.Neutral9,
                  display: 'inline-block',
                  marginX: '4px', // Add some margin on both sides
                }}
              />
              <Box sx={{ display: 'flex', gap: '8px' }}>
                <img
                  src={'/assets/zoominfo-employee.svg'}
                  alt='logo'
                  loading='lazy'
                  style={{
                    width: '20px',
                    height: '20px',
                  }}
                />
                {loading ? (
                  <Skeleton
                    variant='text'
                    sx={{
                      fontSize: theme.typography.body2,
                      width: '5rem',
                      backgroundColor: zeplinColor.Neutral4,
                      // Optionally adjust other styles here
                    }}
                  />
                ) : (
                  <Typography variant='responsiveBody3' color={zeplinColor.Neutral1}>
                    {dataDetails?.item?.employeeCount} Employees
                  </Typography>
                )}
              </Box>
              <Box
                sx={{
                  height: '16px',
                  width: '1px',
                  backgroundColor: zeplinColor.Neutral9,
                  display: 'inline-block',
                  marginX: '4px', // Add some margin on both sides
                }}
              />
              <Box sx={{ display: 'flex', gap: '8px' }}>
                <img
                  src={'/assets/zoominfo-dollar.svg'}
                  alt='logo'
                  loading='lazy'
                  style={{
                    width: '20px',
                    height: '20px',
                  }}
                />
                {loading ? (
                  <Skeleton
                    variant='text'
                    sx={{
                      fontSize: theme.typography.body2,
                      width: '5rem',
                      backgroundColor: zeplinColor.Neutral4,
                      // Optionally adjust other styles here
                    }}
                  />
                ) : (
                  <Typography variant='responsiveBody3' color={zeplinColor.Neutral1}>
                    {dataDetails?.item?.revenueRange}
                  </Typography>
                )}
              </Box>
            </Box>
          </Box>
        }
        DealCard={<Box />}
        DashboardTabs={DashboardTabs}
        handleChange={handleChange}
        value={value}
        alert={alert}
        handleClose={handleClose}
        Children={''}
      />
    </>
  );
};

export default ZoomInfoSelected;
